import { render, staticRenderFns } from "./chinh-sach.vue?vue&type=template&id=6af975f8"
import script from "./chinh-sach.vue?vue&type=script&lang=js"
export * from "./chinh-sach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports